var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.67542976 0.28604898 3.34385343 0.61781233 5 1 C4.45276317 4.37462715 3.9451 6.08235 2 9 C1.75780685 11.97449608 1.75780685 11.97449608 1.875 15.1875 C1.90207031 16.81751953 1.90207031 16.81751953 1.9296875 18.48046875 C1.95289063 19.31191406 1.97609375 20.14335937 2 21 C-0.64 21 -3.28 21 -6 21 C-6 20.34 -6 19.68 -6 19 C-4.02 19 -2.04 19 0 19 C-0.33 16.36 -0.66 13.72 -1 11 C-1.9590625 11.2784375 -1.9590625 11.2784375 -2.9375 11.5625 C-3.618125 11.706875 -4.29875 11.85125 -5 12 C-6 11 -6 11 -6.0625 8.4375 C-6.041875 7.633125 -6.02125 6.82875 -6 6 C-5.01 5.67 -4.02 5.34 -3 5 C-1.8499169 3.03327085 -1.8499169 3.03327085 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z M-2 5 C-1.67 5.66 -1.34 6.32 -1 7 C-0.67 6.34 -0.34 5.68 0 5 C-0.66 5 -1.32 5 -2 5 Z ",
    fill: "#698B6F",
    transform: "translate(19,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C11.67 0.66 11.34 1.32 11 2 C8.03 2 5.06 2 2 2 C2 6.62 2 11.24 2 16 C3.98 16 5.96 16 8 16 C8.33 16.66 8.66 17.32 9 18 C6.03 18 3.06 18 0 18 C0 12.06 0 6.12 0 0 Z ",
    fill: "#698A6F",
    transform: "translate(3,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.ecf8d29eee352990be2cdcff6f88f941.svg";
export { ForwardRef as ReactComponent };